module.exports = __webpack_public_path__ + "img/icon-amex.90e00dc0.svg";